<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view/>
    <!-- <Footer></Footer> -->
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      isShowBack: false
    }

  },
  watch:{
    '$route':function(){
      let that = this
      if(that.$route.name == 'home'){
        that.isShowBack = false;
      }else{
        that.isShowBack = true;
      }
    }
  },
  mounted() {
  }
}
</script>

<style>
/* #app{
  min-width: 1320px;
} */
 html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #f5f8f6;
  font-size: 18px;   /* 整体字号加大 */
}

#app {
  display: flex;
  justify-content: center;  /* 居中内容 */
}

.traceability-page {
  width: 100%;
  max-width: 480px;   /* 限制内容最大宽度 */
  margin: 0 auto;
  background: #f5f8f6;
}

</style>



// WEBPACK FOOTER //
// src/App.vue